<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="4" md="3" lg="2">
      <FilterSelect
        :items="filterChargeStatus"
        :fetchData="fetchAdminCharges"
        item-value="value"
        item-text="label"
        label="Status"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="4" md="3" lg="2">
      <FilterSelect
        :items="filterChargeTypes"
        :fetchData="fetchAdminCharges"
        item-value="value"
        item-text="label"
        label="Tipo"
        type="type"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="3">
      <FilterAutocomplete
        :label="$t('genericFilters.label.customer')"
        :fetchData="fetchAdminCharges"
        :asyncSearch="searchCustomers"
        :loading="isCustomersLoading"
        :items="customers"
        type="realEstateId"
        value="id"
      />
    </v-col>
    <v-col cols="12" sm="4" md="3" lg="3">
      <FilterDates :fetchData="fetchAdminCharges" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'
import FilterSelect from '@/components/filters/FilterSelect'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChargeListFilters',

  components: {
    FilterDates,
    FilterSelect,
    FilterAutocomplete
  },

  computed: {
    ...mapGetters([
      'isCustomersLoading',
      'customers',
    ]),
  },

  methods: {
    ...mapActions(['fetchAdminCharges', 'searchCustomers']),
  },

  data() {
    return {
      filterChargeStatus: [
        { label: this.$t('charge.status.PENDING'), value: 'PENDING' },
        { label: this.$t('charge.status.RECEIVED'), value: 'RECEIVED' },
        { label: this.$t('charge.status.CONFIRMED'), value: 'CONFIRMED' },
        { label: this.$t('charge.status.OVERDUE'), value: 'OVERDUE' },
        { label: this.$t('charge.status.OTHER'), value: 'OTHER' },
      ],

      filterChargeTypes: [
        { label: this.$t('charge.types.FCI'), value: 'FCI' },
        { label: this.$t('charge.types.RENT_OUT'), value: 'RENT_OUT' },
        { label: this.$t('charge.types.EVICTION'), value: 'EVICTION' },
      ],
    }
  },

  mounted() {
    this.searchCustomers()
  },
}
</script>
